import { LocalStorage } from "../../../shared/core/localStorage";
import { Locales } from "../constants";

export class LocaleHelper {

    // take culture for locale translations. All cultures that start with es are translated into es-ES
    // If user selects culture, return selected
    static toLocaleCulture(culture: string): string {
        const storedCulture = LocalStorage.get("lcl");
        culture = (storedCulture === null || storedCulture === undefined) ? culture : storedCulture;
        if (!culture) {
            console.warn("LocaleHelper: missing culture, falling back to default locale (en-US).");
            return Locales.enUS;
        }

        const prefix = culture.split("-")[0];
        if (prefix === "es") {
            return this.isSupportedSpanishLocale(culture) ? culture : Locales.esES;
        }

        return culture;
    }

    public static defaultFallBack(culture: any) {
        const storedCulture = LocalStorage.get("lcl");
        culture = (storedCulture === null || storedCulture === undefined) ? culture : storedCulture;
        if (this.isSpanishLocale(culture)) {
            return this.getSpanishFallback();
        }
        return Locales.enUS;
    }

    /**
     * Converts long locale codes (with country as ISO 3166) to short locale codes (ISO 639-1).
     * @description e.g. "es-ES" converts to "es"
     * @example toShortLocaleCode("es-ES")
     * @param locale Long locale code
     * @returns Short locale code
     */
    public static toShortLocaleCode(locale: string): string {
        const parts = locale.split("-");
        if (parts.length > 0) {
            return parts[0];
        }
        return locale;
    }

    private static isSpanishLocale(culture: string): boolean {
        return culture?.split("-")[0] === "es";
    }

    private static getSpanishFallback(): Locales {
        return Locales.esES;
    }

    private static isSupportedSpanishLocale(culture: string): boolean {
        return this.supportedSpanishLocales.has(culture as Locales);
    }

    private static readonly supportedSpanishLocales = new Set<Locales>([
        Locales.esES,
        Locales.esMX,
        Locales.esVE
    ]);

}
